export default "__VITE_ASSET__C1jBW1Rb__"